export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const extractContextId = (event: unknown): string | undefined => {
  if (!isRecord(event)) return undefined;

  const direct = event.contextId;
  if (typeof direct === "string") return direct;

  const result = event.result;
  if (isRecord(result)) {
    const nested = result.contextId;
    if (typeof nested === "string") return nested;
  }

  return undefined;
};

export const extractTaskId = (event: unknown): string | undefined => {
  if (!isRecord(event)) return undefined;

  const direct = event.taskId;
  if (typeof direct === "string") return direct;

  return undefined;
};
